import Popup from "../../Popup/Popup";
import PartsTable from "./PartsTable";

const PartsPopup = ({
  setPartsModalOpen,
  handleSelectPart,
  disableFilter = true,
  disableActions = false,
  items_type = "all",
  title = "Item Code Table",
  checkRevCreated = false,
  check_module_created = false,
  checkRevReleased = false,
  checkRevCreatedNot,
  useTableInAuditTrail = false,
  auditTrailRow,
  disableBomOptions = false,
  customQueryParams = "",
  disableActionButtons = false,
  isMyCanvasCase = false,
  onPartUpdated = null,
}) => {
  return (
    <Popup
      title={title}
      closeModal={setPartsModalOpen}
      isMyCanvasCase={isMyCanvasCase}
    >
      <PartsTable
        onSelectPart={handleSelectPart}
        items_type={items_type}
        disableFilter={disableFilter}
        disableActions={disableActions}
        checkRevCreated={checkRevCreated}
        check_module_created={check_module_created}
        checkRevReleased={checkRevReleased}
        checkRevCreatedNot={checkRevCreatedNot}
        useTableInAuditTrail={useTableInAuditTrail}
        auditTrailRow={auditTrailRow}
        disableBomOptions={disableBomOptions}
        onCloseParentPopup={setPartsModalOpen}
        customQueryParams={customQueryParams}
        disableActionButtons={disableActionButtons}
        onPartUpdated={onPartUpdated}
      />
    </Popup>
  );
};

export default PartsPopup;
